import { createFileRoute } from '@tanstack/react-router'
import { StageDeliveryPage } from '@/lib/StageDeliveryPage'

export const Route = createFileRoute('/interviews')({ component: InterviewsPage })

function InterviewsPage() {
  return <StageDeliveryPage stage="interview" title="Interviews" subtitle="Roles with candidates in the client's interview rounds." />
}
